import { availableTechnicianDates } from "constants/availableTechnicianDates";
const initialState = {
  availableTechnicianDates: {},
};

const availableDates = (state = initialState, action) => {
  switch (action.type) {
    case availableTechnicianDates:
      return { ...state, availableTechnicianDates: action.payload };
    default:
      return state;
  }
};

export default availableDates;
